export default __webpack_public_path__ + "static/media/drawing-man2-focusfill.bfd7f35f.svg";